(() => {
  const groups = [...document.querySelectorAll('.nfc-nav-group')];
  groups.forEach((group) => group.addEventListener('toggle', () => {
    if (group.open) groups.forEach((other) => { if (other !== group) other.open = false; });
  }));
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nfc-nav-group')) groups.forEach((group) => { group.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const focusedGroup = event.target.closest('.nfc-nav-group');
    groups.forEach((group) => { group.open = false; });
    focusedGroup?.querySelector('summary')?.focus();
  });
})();
